/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Settings_Dirs_Toast_Delete_Error_DescInputs */

const es_settings_dirs_toast_delete_error_desc = /** @type {(inputs: Settings_Dirs_Toast_Delete_Error_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudo eliminar ${i?.label}.`)
};

const en_settings_dirs_toast_delete_error_desc = /** @type {(inputs: Settings_Dirs_Toast_Delete_Error_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not delete ${i?.label}.`)
};

/**
* | output |
* | --- |
* | "Could not delete {label}." |
*
* @param {Settings_Dirs_Toast_Delete_Error_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_dirs_toast_delete_error_desc = /** @type {((inputs: Settings_Dirs_Toast_Delete_Error_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Dirs_Toast_Delete_Error_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_dirs_toast_delete_error_desc(inputs)
	return en_settings_dirs_toast_delete_error_desc(inputs)
});
export { settings_dirs_toast_delete_error_desc as "settings.dirs.toast.delete_error_desc" }